import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { appearance } from 'src/app/config/appearance';
import { RoutingDataService } from '../../angular-common/routing-data.service';
import { MenuNode } from '../base-types';
import { BaseView } from '../base-view';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent extends BaseView {

  firstElementHover: boolean;
  hover:boolean[]=[]

  constructor(
    public routingDataService: RoutingDataService,
    protected _injector: Injector
  ) {
    super(_injector)
  }

  breadcrumbClick = (node: MenuNode) => {
    // Attenzione: non bisogna mai navigare verso url con url params non sostituiti opportunamente. Es: /iam/roles/:id/edit
    // In questo caso bisogna prima recuperare i valori dei parametri dalla url corrente (prima della navigazione) e sostituirli nella url del nodo target
    
    const paramsPosition = this.routingDataService.getParamsPositions(node.url);
    this._debug(`BreadcrumbsComponent.breadcrumbClick(${node.url})`, 'paramsPosition', paramsPosition)
    const params = this.routingDataService.extractUrlParamsFromEffectiveUrl(this.routingDataService.currentUrl, paramsPosition)
    this._debug(`BreadcrumbsComponent.breadcrumbClick(${node.url})`, 'params', params) 
    const targetUrl = this.routingDataService.setUrlParams(node.url, params)
    this._debug(`BreadcrumbsComponent.breadcrumbClick(${node.url})`, 'targetUrl', targetUrl) 

    this._injector.get(Router).navigate([targetUrl])
  }

  private _debug = (func, key, value, primary?: boolean) => {
    let color, background;
    if(primary){
      color = 'white';
      background = 'green';
    }else{
      color = 'black';
      background = 'transparent';
    }
    console.log(`%c RoutingDataService.${func} - ${key}: ${value}`, `background: ${background}; color: ${color}; border:2px solid green; padding: 2px;`);
  }
}
